/*
 * @Autor: dingxiaolin
 * @Date: 2021-01-05 14:03:08
 * @LastEditors: qiuwenjing qiuwenjing@vip56.cn
 * @LastEditTime: 2023-05-10 11:15:27
 */
import Vue from 'vue';
import Vuex from 'vuex';
import app from './modules/app';
import area from "./modules/area";
import login from './modules/login';
import { AliyunPad } from '@/http';

Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
        blobUrl: '',
        ossBucket: '', //ali-oss
        asyncRouterMap: [],
        isFirst: true,
        seacheObj: {},
        ossInfo: {
            tempAccessKeyId: '',
            tempAccessKeySecret: '',
            tempSecurityToken: '',
        },
    },
    mutations: {
        judgeDomain: (state, data) => {
            if (process.env.NODE_ENV === 'production') {
                state.ossBucket = "sinostorage"
            } else {
                state.ossBucket = "sinostoragedev"
            }
        },
        updateOssInfo:async (state, data) => {
            state.ossInfo=data
         },
    },
    actions: {
        setSeacheObj({ commit, state }, products) {
            state.seacheObj = products
        },
        async setOssInfo({ commit, state }){
            let res= await AliyunPad.GetAliyunSTS();
            await commit('updateOssInfo',res);
        },
    },
    modules: {
        app,
        area,
        login
    }
});

export default store;



// WEBPACK FOOTER //
// ./src/vuex/index.ts